/**
 * Get all focusable elements inside of the specifed context.
 *
 * @param  {String} [context='document'] The DOM context you want to search in.
 * @return {Array}  Array of focusable elements
 */
export const getFocusable = (context = "document") => {
  let focusable = Array.from(
    context.querySelectorAll(
      'button, [href], select, textarea, input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])'
    )
  )
  return focusable
}

/**
 * Get the first focusable element inside of the specified context.
 *
 * @param  {String} [context='document'] The DOM context you want to search in.
 * @return {Object} A DOM element
 */
export const getFirstFocusable = (context = "document") => {
  let focusable = getFocusable(context)
  return focusable[0]
}

export const getNextSibling = (elem, selector) => {
  // Get the next sibling element
  var sibling = elem.nextElementSibling

  // If there's no selector, return the first sibling
  if (!selector) return sibling

  // If the sibling matches our selector, use it
  // If not, jump to the next sibling and continue the loop
  while (sibling) {
    if (sibling.matches(selector)) return sibling
    sibling = sibling.nextElementSibling
  }
}

export const getPreviousSibling = (elem, selector) => {
  // Get the next sibling element
  var sibling = elem.previousElementSibling

  // If there's no selector, return the first sibling
  if (!selector) return sibling

  // If the sibling matches our selector, use it
  // If not, jump to the next sibling and continue the loop
  while (sibling) {
    if (sibling.matches(selector)) return sibling
    sibling = sibling.previousElementSibling
  }
}
